import { useState } from "react";
import { useSmartProductSearch } from "@/hooks/useSmartProductSearch";
import { useNavigate } from "react-router-dom";
import { Input } from "../ui/input";
import { ScrollArea } from "../ui/scroll-area";
import { useAppSelector } from "@/store/hooks";

const SearchDropdown = () => {
  const { input, setInput, results, loading } = useSmartProductSearch();



  const navigate = useNavigate();
  const { brandsMap } = useAppSelector((state) => state.app);

  const handleProductClick = (productId: string) => {
    // onOpenChange(false);
    setInput("");
    window.location.replace(`/product/${productId}`);
  };

//   if (!open) return null;

  return (
    <div className="w-80 p-2">
      <div className="flex items-center border-b pb-2">
        <Input
          type="text"
          placeholder="Search product..."
          value={input}
          onChange={(e) => {
            setInput(e.target.value);
          }}
          className="flex-1 border-none shadow-none focus:ring-0 focus-visible:ring-0"
        />
        <button className="ml-2 text-gray-400 hover:text-gray-600" onClick={() => setInput("")}>
          ×
        </button>
      </div>
      <div className="mt-2">
        <div className="text-xs text-gray-500 px-2 mb-1">Products</div>
        {input.trim() === "" ? (
          <div className="text-sm text-gray-400 px-2 py-2">Type to search for products</div>
        ) : loading ? (
          <div className="text-sm text-gray-400 px-2 py-2">Searching...</div>
        ) : results.length === 0 ? (
          <div className="text-sm text-gray-400 px-2 py-2">No products found</div>
        ) : (
          <ScrollArea className="max-h-60">
            {results.map((product) => (
              <div
                key={product.product_id || product.id}
                className="px-2 py-2 hover:bg-gray-100 rounded cursor-pointer"
                onClick={() => handleProductClick(product.product_id || product.id)}
              >
                <div className="font-medium">{product.name}</div>
                <div className="text-xs text-gray-500 flex items-center gap-2">
                  <span>{brandsMap?.[product?.brand_id]?.name}</span>
                  <span className="text-gray-400">·</span>
                  <span className="font-semibold text-base text-gray-900">
                    ${product.price?.toFixed(2)}
                  </span>
                </div>
              </div>
            ))}
          </ScrollArea>
        )}
      </div>
    </div>
  );
};

export default SearchDropdown;
